import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiError } from '../../abstract/api-error';
import { ApiService } from '../../abstract/api.service';
import { AcresAdvantageDashboard } from '../response-models/acres-advantage-dashboard.model';
import { isRecord } from '../utils/is-record';

/**
 * Acres Advantage dashboard data: `GET /organizations/:organizationId/acres-advantage`
 * (hub `user-acres-advantage-controller.ts`). Points earned, sponsor breakdowns and summary statistics.
 *
 * Reference: /agent-os/specs/2026-02-11-acres-advantage/spec.md
 */
@Injectable({
  providedIn: 'root'
})
export class AcresAdvantageService extends ApiService {
  constructor() {
    super('acres-advantage');
  }

  /** Dashboard data for an organization. Emits an `ApiError` on failure or when the hub sends no data. */
  getDashboardData(organizationId: string): Observable<AcresAdvantageDashboard> {
    return this.request('GET', { prefix: ['organizations', organizationId] }, toDashboard);
  }
}

function toDashboard(data: unknown): AcresAdvantageDashboard {
  if (!isRecord(data)) {
    throw new ApiError(0, [], { code: 'EMPTY_RESPONSE' }, 'Failed to load Acres Advantage dashboard data');
  }
  return data as unknown as AcresAdvantageDashboard;
}
